import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';
import { ThemeEvents, CartUpdateEvent } from '@theme/events';

/**
 * Upsell component that listens to quantity selector changes and
 * updates the cart for the finishing edges variant via cart update API.
 */
class UpsellFinishingEdgesComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#onQuantityChange.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener(ThemeEvents.quantitySelectorUpdate, this.#onQuantityChange.bind(this));
    super.disconnectedCallback();
  }

  /**
   * @param {CustomEvent<{quantity: number}>} event
   */
  async #onQuantityChange(event) {
    // Only react to events from within this component
    if (!(event.target instanceof HTMLElement) || !this.contains(event.target)) return;

    const variantId = this.dataset.variantId;
    const quantity = Number(event.detail?.quantity ?? 0);
    if (!variantId) return;

    // Collect sections from any cart-items-component instances for live morphing
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = new Set();
    cartItemsComponents.forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        sectionIds.add(el.dataset.sectionId);
      }
    });

    const body = JSON.stringify({
      updates: { [variantId]: quantity },
      sections: Array.from(sectionIds),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(Theme.routes.cart_update_url, fetchConfig('json', { body }));
      const data = await response.json();

      // Dispatch a cart update so cart UI can morph itself
      this.dispatchEvent(new CartUpdateEvent({}, this.id, { sections: data.sections }));
    } catch (error) {
      console.error(error);
    }
  }
}

if (!customElements.get('upsell-finishing-edges-component')) {
  customElements.define('upsell-finishing-edges-component', UpsellFinishingEdgesComponent);
}